

import {ParsedUrlParams} from "./urlparams";


export default class DisplayChannel {

    public static is(params: ParsedUrlParams) : boolean {
        if (typeof(params['dclid']) !== 'undefined') {
            return true;
        }
        return false;
    }

}